/*
 * @Descripttion: store getter
 * @FilePath: /mall-wap-vue/src/store/getters.js
 * @Author: 张兴业
 * @Date: 2020-09-24 15:17:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-22 23:25:44
 */
const getters = {
  token: state => state.login.token,
  retailHomepage: state => state.home.retailHomepage,
  homeProductList: state => state.home.homeProductList,
  findStoreByCondition: state => state.home.findStoreByCondition,
  queryRetailStoreThemeDetail: state => state.home.queryRetailStoreThemeDetail,

  addressData: state => state.mine.addressData,
  getUserInfo: state => state.mine.getUserInfo,
  // queryCardVoucherUserCount: state => state.mine.queryCardVoucherUserCount,
  findCertificationByPage: state => state.mine.findCertificationByPage,
  truePhone: state => state.mine.truePhone,
  getUserAddressList: state => state.mine.getUserAddressList,
  getAddressById: state => state.mine.getAddressById,
  queryCardVoucherUserPackage: state => state.mine.queryCardVoucherUserPackage,
  queryCardVoucherUserByPage: state => state.mine.queryCardVoucherUserByPage,
  queryCardVoucherUserRecordByPage: state =>
    state.mine.queryCardVoucherUserRecordByPage,
  queryCardVoucherUserById: state => state.mine.queryCardVoucherUserById,
  getSimpleUserInfo: state => state.mine.getSimpleUserInfo,
  couponList: state => state.mine.couponList,

  categoriesList: state => state.product.categoriesList,
  searchProductList: state => state.product.searchProductList,
  searchFoundList: state => state.product.searchFoundList,
  searchKeys: state => state.product.searchKeys,
  mallretailspu: state => state.product.mallretailspu,
  queryBrandById: state => state.product.queryBrandById,

  getCartList: state => state.cart.getCartList,
  preCheckout: state => state.cart.preCheckout,
  checkout: state => state.cart.checkout,
  mallretailspuChoice: state => state.cart.mallretailspuChoice,

  code: state => state.load.code,
  msg: state => state.load.msg,

  getUserOrder: state => state.order.getUserOrder,
  searchOrderKeys: state => state.order.searchOrderKeys,
  getTrackingDataBySubOrderSn: state => state.order.getTrackingDataBySubOrderSn,
  toExchangeCardVoucher: state => state.order.toExchangeCardVoucher,
  getAfterSaleList: state => state.order.getAfterSaleList,
  getAfterSaleInfo: state => state.order.getAfterSaleInfo,
  getNegotiationHistory: state => state.order.getNegotiationHistory,
  getDistributionPlan: state => state.order.getDistributionPlan,
  getAfterLogistics: state => state.order.getAfterLogistics,
  getOptionalAfterOrder: state => state.order.getOptionalAfterOrder,
  getPeriodOptionalAfterOrder: state => state.order.getPeriodOptionalAfterOrder,
  getContactor: state => state.order.getContactor,
  getTrackingDataByTrackingNo: state => state.order.getTrackingDataByTrackingNo,
  getTrackingDataByOrderSn: state => state.order.getTrackingDataByOrderSn,
  queryCardVoucherUserByIdNoUserId: state =>
    state.order.queryCardVoucherUserByIdNoUserId,
  findClientRetailOrderByParam: state =>
    state.order.findClientRetailOrderByParam,
  getClientRetailOrderState: state => state.order.getClientRetailOrderState
};

export default getters;
